module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "add-point-step"
    }
  }, [_c('step-template', [_c('div', {
    attrs: {
      "slot": "back"
    },
    on: {
      "click": _vm.close
    },
    slot: "back"
  }, [_vm._v("←")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('div', {
    staticClass: "font-bold mb-4"
  }, [_vm._v("Tap on the map to show where in the world you are")]), _vm._v(" "), _c('div', [_vm._v("You can zoom in to get a bit more precise.")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49f1aaa0","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/AddPointStep.vue
// module id = 170
// module chunks = 0